export const shortenOrderNumber = (value) => {
  const orderNumber = String(value || '').trim()
  if (!orderNumber) {
    return '-'
  }

  const match = orderNumber.match(/^([A-Z]+)-(\d{8})-(\d{6})-([A-Z0-9]+)$/)
  if (!match) {
    return orderNumber
  }

  const [, prefix, yyyymmdd, , suffix] = match
  const yy = yyyymmdd.slice(2, 4)
  const mm = yyyymmdd.slice(4, 6)
  const dd = yyyymmdd.slice(6, 8)

  return `${prefix}-${dd}${mm}${yy}-${suffix}`
}
